import { Chip, makeStyles } from '@material-ui/core';

import { DeliveryNoteOrder } from '../../types/delivery-note-order.type';
import { formatPhoneNumber } from '../../../shared/utils/format-phone-number.util';
import OrderStatusChip from '../Chips/OrderStatusChip.component';
import { formatPrice } from '../../../shared/utils/format-price.util';
import pluralFormatter from '../../../shared/utils/plural-formater';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    gap: '1rem',
    padding: '0.75rem 1rem',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    pageBreakInside: 'avoid',
    breakInside: 'avoid',

    '& p': {
      margin: '0 0 0.25rem 0',
    },
  },

  customer: {
    flexBasis: '25%',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',

    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      marginBottom: '5px',
    },
  },

  orderCountChip: {
    fontWeight: 'bold',
    borderRadius: '5px',
    marginBottom: '0.5rem',
  },

  itemsCountChip: {
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,
  },

  items: {
    flexBasis: '60%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '0.2rem',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',

    '& ul': {
      margin: 0,
      paddingLeft: '1.25rem',
    },
  },

  recap: {
    flexBasis: '15%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    gap: '0.5rem',
  },

  totalChip: {
    borderRadius: '5px',
  },
}));

type Props = {
  order: DeliveryNoteOrder;
  index: number;
  orderCount: number;
};

export default function DeliveryNoteOrderRow({ order, index, orderCount }: Props) {
  const classes = useStyles();

  const itemsCount = order.items.reduce((count, item) => count + item.quantity, 0);

  return (
    <section className={classes.root}>
      <div className={classes.customer}>
        <div>
          <Chip className={classes.orderCountChip} size="small" label={`Commande ${index} / ${orderCount}`} />
          <Chip
            className={classes.itemsCountChip}
            size="small"
            color="secondary"
            label={
              <b>
                {pluralFormatter({
                  count: itemsCount,
                  singular: `${itemsCount} produit`,
                  plural: `${itemsCount} produits`,
                })}
              </b>
            }
            style={{ borderRadius: '5px' }}
          />
        </div>
        <p>{order.owner}</p>
        <p>{formatPhoneNumber(order.phone)}</p>
      </div>

      <div className={classes.items}>
        {order.items
          .sort((a, b) => a.quantity - b.quantity)
          .map((item) => (
            <p key={item.id}>
              <Chip size="small" color="secondary" label={<b>×{item.quantity}</b>} style={{ borderRadius: '5px' }} />{' '}
              {item.name}
            </p>
          ))}
      </div>

      <div className={classes.recap}>
        <Chip className={classes.totalChip} size="small" label={formatPrice(order.total)} />
        <OrderStatusChip size="small" status={order.status} />
      </div>
    </section>
  );
}
